import { useSyncExternalStore } from "react";

const MOBILE_BREAKPOINT_PX = 768;
const MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`;

const subscribe = (callback: () => void) => {
  if (typeof window === "undefined") return () => {};
  const mediaQuery = window.matchMedia(MEDIA_QUERY);
  mediaQuery.addEventListener("change", callback);
  return () => mediaQuery.removeEventListener("change", callback);
};

const getSnapshot = (): boolean => {
  if (typeof window === "undefined") return false;
  return window.matchMedia(MEDIA_QUERY).matches;
};

const getServerSnapshot = (): boolean => false;

/**
 * Соответствует Tailwind-брейкпоинту `md` (>= 48rem). На совпадении с media query
 * `(max-width: 767px)` возвращает true.
 */
export const useIsMobile = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
